import KEYWORDS from '../keywords';
import { TenantsDisplay } from '../modules/Tenants';

const { ROUTES } = KEYWORDS;

const authorizedDisplayKeys = {
	TENANTS: ROUTES.FEED_TENANTS.PATH,
};

const authorizedDisplayComponents = {
	[authorizedDisplayKeys.TENANTS]: TenantsDisplay,
};

export default class DisplayBuilderConfig {
	static getAuthorizedDisplayReactNodes() {
		return authorizedDisplayComponents;
	}
}
